"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipStyles = void 0;

var _styledComponents = require("styled-components");

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

var tooltipStyles = {
  gap: (0, _getSpacing.getSpacing)(2),
  padding: (0, _styledComponents.css)(["", " ", ""], (0, _getSpacing.getSpacing)(2), (0, _getSpacing.getSpacing)(4)),
  zIndex: 100,
  backgroundColor: (0, _getColor.getColor)('common', 'black'),
  color: (0, _getColor.getColor)('common', 'white'),
  borderRadius: 4
};
exports.tooltipStyles = tooltipStyles;